import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import api from '../services/api';

const Contact = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleChange = (key) => (e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
    if (error) setError('');
    if (success) setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await api.post('/contact', {
        name: form.name,
        email: form.email,
        subject: form.subject,
        message: form.message,
      });
      setSuccess('Message envoyé. Nous vous répondrons au plus vite.');
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      const status = err.response?.status;
      const apiError = err.response?.data?.error || err.response?.data?.message;
      if (status === 400) {
        setError(apiError || 'Veuillez vérifier les champs du formulaire.');
      } else {
        setError(apiError || 'Impossible d\'envoyer le message. Réessayez plus tard.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: { xs: 2.5, md: 4 } }}>
        <Typography variant="h3" fontWeight={900} sx={{ mb: 2 }}>
          Contact
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Une question ? Un besoin ? Écrivez-moi, je vous répondrai au plus vite sur{' '}
          <strong>sgdigitalweb13@gmail.com</strong>.
        </Typography>

        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={2}>
            {success ? <Alert severity="success">{success}</Alert> : null}
            {error ? <Alert severity="error">{error}</Alert> : null}

            <TextField
              label="Nom"
              value={form.name}
              onChange={handleChange('name')}
              required
              autoComplete="name"
            />
            <TextField
              label="Email"
              type="email"
              value={form.email}
              onChange={handleChange('email')}
              required
              autoComplete="email"
            />
            <TextField
              label="Sujet"
              value={form.subject}
              onChange={handleChange('subject')}
              required
            />
            <TextField
              label="Message"
              value={form.message}
              onChange={handleChange('message')}
              required
              multiline
              minRows={6}
            />

            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button type="submit" variant="contained" disabled={loading}>
                {loading ? 'Envoi...' : 'Envoyer'}
              </Button>
            </Box>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
};

export default Contact;
